import React from 'react'
import TextWithLink from './TextWithLink'

import LoginInfo from './LoginInfo'
import RegisterForm from '../containers/Register/RegisterForm'

const Register = () => (
  <section className='account-form-wrapper'>
    <div className='title'>Register an account</div>
    <RegisterForm />
    <TextWithLink
      text='Already have an account?'
      linkTest='Sign in'
      link='/signin'
    />
    <hr />
    <LoginInfo
      termsLink='https://goshopmatic.com/terms.html'
      policyLink='https://goshopmatic.com/privacy.html'
    />
  </section>
)

export default Register
